import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {AthleteNextGameModuleConfig} from "./athlete-next-game.module.config";
import {AthleteNextGameModuleStore} from "./athlete-next-game.module.store";
import {AthleteNextGameModuleHandlers} from "./handlers/athlete-next-game.module.handlers";

export class AthleteNextGameModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, AthleteNextGameModuleConfig, AthleteNextGameModuleStore, AthleteNextGameModuleHandlers];
}
